import { render, staticRenderFns } from "./NewslettersGroups.vue?vue&type=template&id=5339da73&scoped=true"
import script from "./NewslettersGroups.vue?vue&type=script&lang=js"
export * from "./NewslettersGroups.vue?vue&type=script&lang=js"
import style0 from "./NewslettersGroups.vue?vue&type=style&index=0&id=5339da73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5339da73",
  null
  
)

export default component.exports